/**
 * Volume estimation tool modes.
 */
export enum Mode {
  None,
  Modelling,
  Reevaluation,
}
